import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { MdInfoOutline } from 'react-icons/md';
import DefaultButton from '../ReusableComponents/DefaultButton';
import { normalizeCandidateLog } from './candidateLogDetails';

const hardwareLabels = [
    ['ramGB', 'Memória RAM'],
    ['nucleosLogicos', 'Processadores lógicos'],
    ['navegador', 'Identificação do navegador'],
    ['plataforma', 'Plataforma'],
];
const displayValue = value => value == null || value === '' ? 'Não informado'
    : typeof value === 'object' ? JSON.stringify(value) : String(value);

export default function CandidateLogMessage({ item: originalItem }) {
    const item = normalizeCandidateLog(originalItem);
    const [open, setOpen] = useState(false);
    if (!item.detalhes) return item.mensagem || '—';
    const hardware = hardwareLabels.some(([key]) => Object.prototype.hasOwnProperty.call(item.detalhes, key));
    const exception = item.detalhes.excecao;
    const message = item.detalhes.mensagem || item.mensagem;
    return <>
        {hardware && <dl className="mb-1" style={{ overflowWrap: 'anywhere' }}>
            {hardwareLabels.map(([key, label]) => <div key={key} className="mb-1">
                <dt className="d-inline"><strong>{label}: </strong></dt>
                <dd className="d-inline m-0">{displayValue(item.detalhes[key])}{key === 'ramGB' && typeof item.detalhes[key] === 'number' ? ' GB' : ''}</dd>
            </div>)}
        </dl>}
        {!hardware && exception && <div><strong>Exceção: </strong>{displayValue(exception)}</div>}
        {!hardware && item.detalhes.mensagem && <strong>Mensagem: </strong>}
        <Button type="button" variant="link" className="p-0 text-left"
            style={{ fontSize: 'inherit', whiteSpace: 'normal' }}
            onClick={() => setOpen(true)} aria-label={`Ver detalhes: ${hardware ? 'Dados da máquina' : message || item.acao}`}>
            <MdInfoOutline aria-hidden="true" className="mr-1" />
            {hardware ? 'Ver JSON completo' : displayValue(message || 'Ver detalhes')}
        </Button>
        <Modal show={open} onHide={() => setOpen(false)} size="lg" centered>
            <Modal.Header closeButton closeLabel="Fechar"><Modal.Title>Detalhes do log</Modal.Title></Modal.Header>
            <Modal.Body>
                <p className="font-weight-bold mb-1">{item.acao}</p>
                <p className="text-muted">{item.hora_inicio}</p>
                <pre className="bg-light border rounded p-3 mb-0" style={{ maxHeight: '60vh', overflow: 'auto', whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>
                    {JSON.stringify(item.detalhes, null, 2)}
                </pre>
            </Modal.Body>
            <Modal.Footer><DefaultButton text="Fechar" bg="secondary" onClick={() => setOpen(false)} /></Modal.Footer>
        </Modal>
    </>;
}
